<template>
  <div>
    <el-dialog
      :visible.sync="pickerVisible"
      :close-on-click-modal="false"
      class="dialog"
      append-to-body
      top="30px"
      width="500px"
      @close="onDialogClose"
    >
      <span slot="title" class="dialog-title">选择模板</span>
      <span>
        打印模板
        <el-select
          @change="printChange"
          v-model="def"
          style="width: 300px; margin-left: 10px"
          size="small"
        >
          <el-option
            v-for="item in list"
            :value="item.printTemplateDetails"
            :label="item.sysPrintName"
            :key="item"
          >
            <div style="display: flex">
              <div style="flex: 1">{{ item.sysPrintName }}</div>
              <div style="font-size: 0.5; color: #1476c3">
                {{ item.sysPrintType }}
              </div>
            </div>
          </el-option>
        </el-select>
        <printHistory
          :printModule="printModule"
          :modules="modules"
          :printFun="printFun"
        ></printHistory>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeShow">取 消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="print()">确 定</el-button>
      </span>
    </el-dialog>
    <print-preview ref="preView" :modules="modules" :printModule="printModule" />
    <vue-easy-print style="display: none" tableShow ref="easyPrint">
      <div id="printArea" v-html="htmlData"></div>
    </vue-easy-print>
  </div>
</template>

<script>
import { sysPrint_getDefaultByModules, sysPrint_list } from '@/api/myController/system';
import vueEasyPrint from 'vue-easy-print';
import printPreview from '@/views/supplier/preview';
import printHistory from './printHistory';
import { print, printDataParse } from '@/utils/print';
import { createNormalizedHiprintTemplate } from '@/utils/printTemplatePaper';
let hiprintTemplate;
export default {
  components: { vueEasyPrint, printPreview, printHistory },
  props: {
    // 打印接口参数
    modules: {
      type: Number,
      required: false,
      default: 0
    },
    // 打印框显示
    showprint: {
      type: Boolean,
      required: false,
      default: false
    },
    // 打印接口加载
    btnLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    htmlDataList: {
      type: String,
      required: false,
      default: ''
    },
    // table多选数据
    changeList: {
      type: Array,
      required: false,
      default() {
        return [];
      }
    },
    // 打印数据
    printData: {
      type: Array,
      required: false,
      default() {
        return [];
      }
    },
    printFun: {
      type: Function,
      required: false,
      default: null
    },
    presetTemplateDetails: {
      type: String,
      default: null
    },
    presetTemplateId: {
      type: [String, Number],
      default: null
    },
    skipPicker: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOld: false,
      list: [],
      htmlData: null,
      printModule: {},
      def: null,
      skipToPreview: false,
      skipOpened: false,
      skipFallbackTimer: null
    };
  },
  computed: {
    pickerVisible: {
      get() {
        if (this.skipPicker) return false;
        return this.showprint;
      },
      set(val) {
        if (!val && !this.skipToPreview) {
          this.closeShow();
        }
      }
    }
  },
  watch: {
    printData: {
      handler() {
        this.trySkipToPreview();
      },
      deep: true
    },
    btnLoading(val) {
      if (!val) {
        this.trySkipToPreview();
        this.ensureSkipFallback();
      }
    }
  },
  created() {
    if (this.skipPicker) this.skipToPreview = true;
  },
  mounted() {
    this.printGetList();
  },
  beforeDestroy() {
    this.clearSkipFallbackTimer();
  },
  methods: {
    onDialogClose() {
      if (this.skipToPreview) return;
      this.closeShow();
    },
    clearSkipFallbackTimer() {
      if (this.skipFallbackTimer) {
        clearTimeout(this.skipFallbackTimer);
        this.skipFallbackTimer = null;
      }
    },
    fallbackToPicker(reason) {
      this.clearSkipFallbackTimer();
      if (this.skipPicker) {
        if (reason) this.$message.warning(reason);
        return;
      }
      if (!this.skipToPreview) return;
      this.skipToPreview = false;
      this.skipOpened = false;
      if (reason) {
        this.$message.warning(reason);
      }
    },
    ensureSkipFallback() {
      if (!this.showprint || !this.skipPicker) return;
      if (!this.skipToPreview || this.skipOpened || this.btnLoading) return;
      if (this.printData && this.printData.length) return;
      this.fallbackToPicker('打印数据未就绪，请选择模板后重试');
    },
    trySkipToPreview() {
      if (!this.showprint || !this.skipPicker) return;
      if (!this.skipToPreview || this.skipOpened || this.btnLoading) return;
      if (this.def == null) {
        this.fallbackToPicker('未找到可用打印模板');
        return;
      }
      if (!this.printData || !this.printData.length) {
        this.ensureSkipFallback();
        return;
      }
      this.clearSkipFallbackTimer();
      this.skipOpened = true;
      this.$nextTick(() => {
        this.print();
      });
    },
    evaluateSkipPicker() {
      if (this.skipPicker && this.def) {
        this.skipToPreview = true;
        this.clearSkipFallbackTimer();
        this.skipFallbackTimer = setTimeout(() => {
          this.ensureSkipFallback();
        }, 12000);
        this.trySkipToPreview();
        return;
      }
      this.skipToPreview = false;
    },
    applyTemplate(item) {
      if (!item) return;
      this.printModule = item;
      this.def = item.printTemplateDetails;
      this.htmlData = this.def;
      this.isOld = this.htmlData && this.htmlData.includes('printTable');
      if (!this.isOld && this.htmlData) {
        var panel = JSON.parse(this.htmlData);
        hiprintTemplate = createNormalizedHiprintTemplate(panel);
      }
    },
    closeShow() {
      this.clearSkipFallbackTimer();
      this.skipToPreview = false;
      this.skipOpened = false;
      this.$emit('close');
    },
    async print() {
      if (this.btnLoading) {
        this.$message.warning('加载中');
        return;
      }
      if (this.def == null) {
        this.$message.warning('未选择打印模板');
        return;
      }
      if (this.changeList.lenth == 0) {
        this.$message.warning('未选择数据');
        return;
      }
      if (this.isOld) {
        const { href } = await this.$router.resolve({
          path: '/startPrint',
          query: { value: this.htmlDataList }
        });
        window.open(href);
      } else {
        setTimeout(() => {
          this.$refs.preView.show(hiprintTemplate, this.printData);
          setTimeout(() => {
            this.printData.totals += 111;
          }, 5000);
        }, 500);
      }
    },
    printChange(e) {
      this.htmlData = e;
      this.def = e;
      this.printModule = this.list.filter((a) => a.printTemplateDetails == e)[0];

      this.isOld = this.htmlData.includes('printTable');
      if (!this.isOld) {
        var panel = JSON.parse(this.htmlData);
        hiprintTemplate = createNormalizedHiprintTemplate(panel);
      }
    },
    // 读出打印模板（仅当前单据 modules，与 userLogin 一致）
    printGetList() {
      const modules = Number(this.modules);
      this.list = [];
      this.def = null;
      this.printModule = {};
      this.htmlData = null;
      if (!modules) {
        this.$message.warning('未配置当前单据的打印模块');
        return;
      }
      sysPrint_list({
        sysPrintDtoFilter: { modules },
        pageParam: { total: 0, pageNum: 1, pageSize: 200 }
      }).then((res) => {
        const dataList = (res.data && res.data.data && res.data.data.dataList) || [];
        // 协同端 listByFilter 可能未按 modules 过滤，前端再按当前单据过滤一次
        this.list = dataList.filter((item) => Number(item.modules) === modules);
        let applied = false;
        if (this.presetTemplateDetails || this.presetTemplateId) {
          const hit = this.list.find((it) => {
            if (
              this.presetTemplateId != null &&
              String(it.sysPrintId) === String(this.presetTemplateId)
            ) {
              return true;
            }
            return (
              this.presetTemplateDetails &&
              it.printTemplateDetails === this.presetTemplateDetails
            );
          });
          if (hit) {
            this.applyTemplate(hit);
            applied = true;
          } else if (this.presetTemplateDetails) {
            this.applyTemplate({
              printTemplateDetails: this.presetTemplateDetails,
              sysPrintId: this.presetTemplateId,
              sysPrintName: '产品标签'
            });
            applied = true;
          }
        }
        if (this.skipPicker && !applied) {
          this.$message.warning('未找到已选产品标签模板，请确认主系统已应用到协同端并完成同步');
          return;
        }
        if (!applied) {
          const defaultItem =
            this.list.find((it) => it.isDefault == 0) || this.list[0] || null;
          if (!defaultItem) {
            this.$message.warning('管理员未在 ERP 打印模板中打开「应用到协同端」');
            this.evaluateSkipPicker();
            return;
          }
          this.applyTemplate(defaultItem);
        }
        this.evaluateSkipPicker();
        if (this.isOld) {
          var data = this.printData;
          if (data) {
            for (const key in data) {
              if (data.hasOwnProperty(key)) {
                const value = data[key];
                var sres = key.trim();
                if (sres.indexOf('DetailList') >= 0 && Array.isArray(value)) {
                  print(that, data, value);
                }
              }
            }
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.e-pr {
  width: 100%;
  top: 20%;
}
</style>
